<template>
  <div class="card-list">
    <div
      v-for="profile in profiles" :key="profile.id"
      class="card-col"
    >
      <router-link
        :to="{
          name: 'AccessProfilesDetailsPage',
          params: { id: profile.id }
        }"
        class="card-item"
      >
        <header class="card-header">
          <h2 class="card-title">{{ profile.name }}</h2>
        </header>
        <div class="card-body">{{ profile.description || '-' }}</div>
        <footer class="card-footer">
          <a
            href="#"
            :title="$t('Common.addEmployees')"
            class="card-link"
            @click.prevent="addEmployees"
          >
            <v-icon>group_add</v-icon>
            {{ $t('Common.addEmployees') }}
          </a>
        </footer>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileCardList',
  props: {
    profiles: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    addEmployees () {
      this.$emit('addEmployees')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-list {
  padding: 0 8px;

  &:before,
  &:after {
    content: '';
    clear: both;
    display: block;
  }
}

.card-col {
  float: left;
  margin-bottom: 8px;
  padding: 0 8px 16px;
  width: 100%;

  @media (min-width: 420px) and (max-width: 767px) {
    width: 50%;
  }

  @media (min-width: 768px) {
    margin-bottom: 0px;
    width: 25%;
  }
}

.card-item {
  background-color: #fff;
  color: $gray-6;
  display: block;
  border: 1px solid #f0f0f0;
  padding: 16px;
  text-decoration: none;
  transition: background .4s, box-shadow .4s;

  &:hover {
    background-color: #fffadd;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.2);
  }
}

.card-title {
  color: $gray-7;
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 12px;
}

.card-body {
  height: 84px;
}

.card-footer {
  padding-top: 16px;
}

.card-link {
  color: $accent;
  padding-left: 30px;
  position: relative;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  .v-icon {
    color: $accent;
    display: inline-block;
    left: 0;
    position: absolute;
    top: 50%;
    vertical-align: middle;
    transform: translateY(-50%);
  }
}
</style>
